import { render, staticRenderFns } from "./feeRow.vue?vue&type=template&id=1ff25658&scoped=true&"
import script from "./feeRow.vue?vue&type=script&lang=tsx&"
export * from "./feeRow.vue?vue&type=script&lang=tsx&"
import style0 from "./feeRow.vue?vue&type=style&index=0&id=1ff25658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff25658",
  null
  
)

export default component.exports